<template>
    <div class="single-answer numerical">
        <div class="q-privew" @copy.prevent @contextmenu="rightClickDisable($event)"  @mouseup="rightClickDisable($event)">
            <div class="q-number" v-if="currentQuestion.questionNo">Q {{ currentQuestion.questionNo }}</div>
            <div class="q-number-Suggestions" v-if="currentQuestion.suggestions">Suggestions {{currentQuestion.suggestions}} </div>
            <div @copy.prevent @contextmenu="rightClickDisable($event)" class="q-type"  :class="{'question-font':!questionFont(currentQuestion)}" v-html="currentQuestion.question_text"></div>
            <div class="pyq-tag-section" v-if="showPyqButton" style="margin-top: 10px; white-space: nowrap;">
                <div
                    v-for="(tag, index) in pyqTags"
                    :key="index"
                    class="pyq-card"
                    style="display: inline-block; margin-right: 8px;"
                >
                    <div class="pyq-btn" style="background-color: #039be5; color: white; padding: 6px 16px; border-radius: 4px; border: 1px solid #039be5; min-width: 60px; text-align: center;">
                        {{ tag }}
                    </div>
                </div>
            </div>
        </div>
        <div v-if="currentQuestion.isMainQuestion !== true">
        <div class="ans-part" v-if="showAnswerField" @copy.prevent @contextmenu="rightClickDisable($event)"  @mouseup="rightClickDisable($event)">
            <div class="que-row">
                <div
                    class="que-col-2"
                    v-if="isPreview || currentQuestion.showAnswerField"
                >
                    <div class="st-tile">
                        <label class="file-title-st">Start Value</label>
                        <v-text-field
                            v-model="currentQuestion.startValue"
                            type="number"
                            :disabled="currentQuestion.disabled  || currentQuestion.isAnswerDisabled"
                            @input="updateAnswer"
                            @keydown.space.prevent
                            @paste.prevent
                            @keypress="allowedOnlyNumber($event)"
                            outlined
                            dense
                            hide-details
							@copy.prevent 
							@contextmenu="rightClickDisable($event)"
                            @mouseup="rightClickDisable($event)"
                        ></v-text-field>
                    </div>
                    <div class="st-tile">
                        <label class="file-title-st">End Value</label>
                        <v-text-field
                            v-model="currentQuestion.endValue"
                            type="number"
                            :disabled="currentQuestion.disabled  || currentQuestion.isAnswerDisabled"
                            @input="updateAnswer"
                            @keydown.space.prevent
                            @paste.prevent
                            @keypress="allowedOnlyNumber($event)"
                            outlined
                            dense
                            hide-details
							@copy.prevent
							@contextmenu="rightClickDisable($event)"
                            @mouseup="rightClickDisable($event)"
                        ></v-text-field>
                    </div>
                </div>
              
                <div :class="practiceSessionView ? 'que-col-2 py-2 numtypequesn-margin-11feb' : 'que-col-2 py-2'" v-else>
                     <v-text-field
                        v-if="currentQuestion.questionType && (currentQuestion.questionType.id === constants.QUE_TYPES.SUBJECTIVE || currentQuestion.questionType.id === constants.QUE_TYPES.COMPREHENSION_2Q_NU)"
                        :class=" inputColour=='red' ? 'numtypequesn-red' : inputColour=='green' ? 'numtypequesn-green': '' "
                        v-model="currentQuestion.correct_answer"
                        type="text"
                        outlined
                        dense
						@copy.prevent
						@contextmenu="rightClickDisable($event)"
                        @mouseup="handleMouseUp($event)"
                        hide-details="auto"
                        :disabled="currentQuestion.disabled" 
                        @input="handleDecimalInput"
                        ref="correctAnswer" 
                        @paste.prevent
                    ></v-text-field>
                     <v-text-field
                        v-else
                        :class=" inputColour=='red' ? 'numtypequesn-red' : inputColour=='green' ? 'numtypequesn-green': '' "
                        v-model="currentQuestion.correct_answer"
                        type="number"
                        outlined
                        dense
						@copy.prevent
						@contextmenu="rightClickDisable($event)"
                        @mouseup="handleMouseUp($event)"
                        hide-details="auto"
                        :disabled="currentQuestion.disabled" 
                        @keypress="validateField($event)"
                        @input="ensureInteger"
                        @keyup="disableField($event)"
                        @mousedown="handleSpinnerClick($event)"
                        ref="correctAnswer" 
                        @paste.prevent
                        step="1"
                        pattern="[0-9]*"
                        inputmode="numeric"
                    ></v-text-field>
                </div>
            </div>
        </div>
        </div>
        <div class="test-solution">
            <div v-if="isPastTest">
                <!-- ansStatus: {{currentQuestion.ansStatus}} -->
                <div>
                    <v-row>
                        <v-col cols="5"
                            ><label class="ans-text-3may">Your Answer: </label>{{ currentQuestion.yourAnswer }}
                            <span v-if="currentQuestion.isBonus">
                                ({{ BONUS_MESSAGE }})
                            </span>
                        </v-col>
                        <v-col cols="6"
                            ><label class="ans-text-3may">Correct Answer:</label>
                            {{ currentQuestion.correctAnswer }}</v-col
                        >
                    </v-row>
                    <!-- <v-row>
                        <v-col cols="2">Hint:</v-col>
                        <v-col cols="10">
                            <div v-html="currentQuestion.hint"></div>
                        </v-col>
                    </v-row>-->
                    <v-row
                        v-if="currentQuestion.solutionVideos && currentQuestion.solutionVideos.length"
						@copy.prevent @contextmenu="rightClickDisable($event)"
                        @mouseup="rightClickDisable($event)"
                    >
                        <v-col cols="12">Video Solution:</v-col>
                        <v-col
                            cols="10"
                            v-for="video in currentQuestion.solutionVideos"
                            :key="video.id"
                        >
                            <div>
                                <video height="100" width="150" controls>
                                    <source :src="video.video_url" />
                                </video>
                            </div>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col class="no-wrap ans-text-3may" cols="3" sm="1">Solution:</v-col>
                        <v-col cols="9" sm="11">
                            <div @copy.prevent @contextmenu="rightClickDisable($event)"  @mouseup="rightClickDisable($event)" v-html="currentQuestion.solution"></div>
                        </v-col>
                    </v-row>
                </div>
            </div>
            <div v-if="(currentQuestion.solution && currentQuestion.isPreview&& currentQuestion.institute_id === null) || this.currentQuestion.isShowSolution">
                <h5 class="Solution">Solution:</h5>
                <div @copy.prevent @contextmenu="rightClickDisable($event)"  @mouseup="rightClickDisable($event)" v-html="currentQuestion.solution"></div>
            </div>
			<div v-else-if="(currentQuestion.solution&&currentQuestion.isPreview) || this.currentQuestion.isShowSolution">
                <h5 class="Solution">Solution:</h5>
                <div @copy.prevent @contextmenu="rightClickDisable($event)"  @mouseup="rightClickDisable($event)" v-html="currentQuestion.solution"></div>
            </div>
        </div>
    </div>
</template>
<script>
import { mapGetters, mapActions, mapState } from "vuex";
import isMobile from "is-mobile";
import constants from "@/utils/constants.js";

export default {
    name: "SubjectivePrivew",
    props: ["currentQuestion", "showAnswerField", "isPreview", "practiceSessionView", "inputColour","openMandatoryQuePopup"],
    computed: {
        ...mapGetters("testStore", ["isPastTest"]),
        ...mapState("userStore", ["user", "myInstitute"]),
        showPyqButton() {
              {console.log("currentQuestion.correct_answer", this.currentQuestion)}
            return (
                this.myInstitute?.id === constants.ONLINE_INSTITUTE_ID &&
                this.user?.role_code === 'ST' &&
                this.currentQuestion?.question_tags &&
                this.pyqTags.length > 0
            );
        },
        pyqTags() {
            if (!this.currentQuestion?.question_tags) return [];
            const tags = this.currentQuestion.question_tags.split(',');
            return tags
                .filter(tag => tag.includes('PYQ_'))
                .map(tag => tag.replace('PYQ_', '').trim());
        }
    },
    data() {
        return {
            ansLength: null,
            constants: constants,
        };
    },
    mounted() {
        console.log("thisadasds", this.currentQuestion)
        this.renderMath();
        this.ansLength = this.currentQuestion && this.currentQuestion.correct_answer ? this.currentQuestion.correct_answer.length : 0;
        this.focusOnField();
    },
    methods: {
        ...mapActions({
            setDisableSecondaryAction: "testStore/setDisableSecondaryAction",
        }),
        updateAnswer() {
           
            // this.question.correct_answer = this.startValue + "##" + this.endValue;
            var startValue = this.currentQuestion.startValue
                ? this.currentQuestion.startValue.toString()
                : "";
            var endValue = this.currentQuestion.endValue
                ? this.currentQuestion.endValue.toString()
                : "";
            this.currentQuestion.correct_answer = startValue + "##" + endValue;
        },
        handleDecimalInput(value) {
            // Allow numbers, decimal point, and negative sign
            const regex = /^-?\d*\.?\d*$/;
            if (!regex.test(value)) {
                this.currentQuestion.correct_answer = value.replace(/[^0-9.-]/g, '');
            }
            if (this.currentQuestion.correct_answer) {
                this.setDisableSecondaryAction(true);
            }
        },
        validateField(event) {
            this.allowedOnlyNumberWithDecimal(event);
            if (this.allowedOnlyNumberWithDecimal(event)) {
                this.setDisableSecondaryAction(true);
            }
        },
        disableField(event) {
            if(this.allowedOnlyNumberWithDecimal(event)) {
                this.setDisableSecondaryAction(true);
            }
        },
        focusOnField() {
            if(!isMobile()) {
                if(this.$refs.correctAnswer) {
                    this.$refs.correctAnswer.focus();
                }
            }
        },
        rightClickDisable(e) {
            e.preventDefault();   
        },
        handleMouseUp(e) {
            this.rightClickDisable(e);
        },
        handleSpinnerClick(e) {
            // Get the input element
            const input = e.target;
            const rect = input.getBoundingClientRect();
            const clickX = e.clientX - rect.left;
            const inputWidth = rect.width;
            
            // Check if click is on the spinner area (right side of input)
            if (clickX > inputWidth - 20) {
                e.preventDefault();
                e.stopPropagation();
                
                const currentValue = parseFloat(this.currentQuestion.correct_answer) || 0;
                const clickY = e.clientY - rect.top;
                const halfHeight = rect.height / 2;
                
                // Determine if click is on up or down arrow
                if (clickY < halfHeight) {
                    // Up arrow clicked
                    this.currentQuestion.correct_answer = currentValue + 1;
                } else {
                    // Down arrow clicked
                    this.currentQuestion.correct_answer = Math.max(0, currentValue - 1);
                }
            }
        },
        async mandatoryQueCount(){
            await this.openMandatoryQuePopup();
            this.currentQuestion.correct_answer = null;
        },
        ensureInteger(value) {
            // Remove any decimal points and non-numeric characters
            if (value && value.toString().includes('.')) {
                this.$nextTick(() => {
                    this.currentQuestion.correct_answer = Math.floor(Math.abs(parseFloat(value)));
                });
            }
        }
    },
    watch: {
        "currentQuestion.correct_answer": function (newVal) {
            if (newVal > "") {
                this.currentQuestion.isAnswered = true;
            } else {
                this.currentQuestion.isAnswered = false;
            }
            if(this.currentQuestion.isAnswered && !this.isPreview) {
                this.setDisableSecondaryAction(true);
            }
            if(this.currentQuestion.isAnswerDisabled === true && this.practiceSessionView!==true){
                this.mandatoryQueCount();
            }
        },
        "currentQuestion.id": function (val) {
            this.focusOnField();
            this.setDisableSecondaryAction(false);
            this.renderMath();
            this.renderMath();
        },
    },
};
</script>